import {FIELD_TYPE_CALCULATED} from './FormService';

export const CalculationFormulaAllowedSymbols = ["Math.max", "Math.min",
  "1", "2", "3", "4", "5", "6", "7", "8", "9", "0",
  "+", ",", "-", ".", "*", "/", "(", ")", "?", ":", ">", "<", "==", "|"
]

const possibleCalculatedFieldTypes = ['radio', 'scale', 'dropdown', 'textfield', 'calculated_field'];


export class CalculationService {

  private form_fields: any[] = [];

  public Fields = []

  GetFieldName(id: number)  {
    let name = '';
    this.Fields.forEach((object: any, k:number) => {
      if (object && Number(object.key) === id) {
        name = object.tag.trim()
      }
    })
    return name;
  }

  GetFieldsCanBeCalculated(newField: any)  {

    if (newField.field_type !== 'radio'
      && newField.field_type !== 'scale'
      && newField.field_type !== 'dropdown'
      && newField.field_type !== 'textfield'
      && newField.field_type !== 'calculated_field'
    ) {
      return false;
    }

    if (newField.field_type === 'textfield' && newField.input_type !== 'number') {
      return false;
    }

    this.Fields.push(
      {
        key: Number(newField.field_id),
        tag: (newField.field_title.trim() === '') ? 'Field-' + (parseInt(newField.field_id) + 1) : newField.field_title.trim()
      }
    );
  }

  RemoveFromCalculationList(fieldId: any) {
    this.Fields.forEach((v, k) => {
      if (typeof v != "undefined" && parseInt(v.key) === parseInt(fieldId)) {
        this.Fields.splice(k, 1);
      }
    });

    this.form_fields.forEach((field:any, k:number) => {
      if (field.field_type.trim() !== FIELD_TYPE_CALCULATED) {
        return true;
      }

      if (typeof this.form_fields[k] == "undefined"
        || typeof this.form_fields[k].selected_fields == "undefined"
        || field.selected_fields.length === 0
      ) {
        return true;
      }

      field.selected_fields.forEach((v:any, k1:number) => {
        if (parseInt(v) === parseInt(fieldId)) {
          this.form_fields[k].selected_fields.splice(k1, 1);
        }
      });
    });

  }

  GetCalculationList(field: any){
    const INPUT_TYPE_NUMBER = 'number';
    if (field.input_type === INPUT_TYPE_NUMBER) {
      this.GetFieldsCanBeCalculated(field);
    } else {
      this.RemoveFromCalculationList(field.field_id)
    }
  }

  SyncFields(form_fields: any[] = []) {
    this.form_fields = form_fields;
    form_fields.forEach((v: any) => {
      if (!possibleCalculatedFieldTypes.includes(v.field_type)
        || (v.field_type === 'textfield' && v.input_type !== 'number')
      ) {
        return true;
      }

      this.Fields.push(
        {
          key: v.field_id,
          tag: (v.field_title.trim() === '') ? 'Field-' + (parseInt(v.field_id) + 1) : v.field_title.trim()
        }
      );
    })
  }

  validateOpenFormula(form: any, field: any) {
    if (field.operation != "open_formula") {
      field.showError = '';
      field.open_formula_formula = '';
      return true;
    }

    field.showError = '';
    if (!field.open_formula_formula || String(field.open_formula_formula).trim() == '') {
      field.showError = 'Formula is empty';
      return false;
    }
    this.setAllowedSymbols(form, field);

    let openBracesCount = field.open_formula_formula.split('(').length,
      closeBracesCount = field.open_formula_formula.split(')').length,
      formulaReplacedAllowedChars: string = field.open_formula_formula.toString(),
      formula = field.open_formula_formula;

    if (openBracesCount != closeBracesCount) {
      field.showError = 'Braces count is incorrect';
      return false;
    }

    if (typeof field.allowedPlaceholders == "undefined") {
      field.allowedPlaceholders = [];
    }

    field.allowedPlaceholders.forEach((v: any) => {
      if (v && typeof v.key != "undefined") {
        formulaReplacedAllowedChars = formulaReplacedAllowedChars.split(v.key).join('');
      }
    })

    CalculationFormulaAllowedSymbols.forEach((v: any) => {
      formulaReplacedAllowedChars = formulaReplacedAllowedChars.split(v).join('');
    })

    formulaReplacedAllowedChars = formulaReplacedAllowedChars.replace(/[A-Z,a-z\u0590-\u05FF]+/g, "");
    formulaReplacedAllowedChars = formulaReplacedAllowedChars.replace(/[',"]+/g, "");

    if (formulaReplacedAllowedChars.trim() != '') {
      field.showError = 'Formula contains not allowed symbols';
      return false;
    }

    try {
      //changing of all placeholders with "1" to make a test sample
      field.allowedPlaceholders.forEach((v1: any, k1: any) => {
        if (v1 && typeof v1.key != "undefined") {
          formula = formula.split(v1.key).join('(' + k1 + ')');
        }
      });

      eval(formula).valueOf();
      let formula2 = field.open_formula_formula;

      field.allowedPlaceholders.forEach((v1: any, k1: any) => {
        if (v1 && typeof v1.key != "undefined") {
          const digitToChange = parseInt(field.allowedPlaceholders.length) - parseInt(k1);
          formula2 = formula2.split(v1.key).join('(' + digitToChange + ')');
        }
      });

      eval(formula2).valueOf();

    } catch (error) {
      field.showError = 'Formula execution leads to error. Please, check your formula.';
      return false;
    }

    return true;
  }

  setAllowedSymbols(form: any, field: any): void {
    if (field.operation != "open_formula") {
      field.showError = '';
      field.open_formula_formula = '';
      field.allowedPlaceholders = [];
      return;
    }


    field.allowedPlaceholders = [];

    form.form_fields.forEach((v: any) => {
      field.selected_fields.forEach((v1: any) => {
        if (v.field_id == v1) {
          let obj: { [index: string]: any } = {};
          obj['key'] = '{' + v.field_id + '}';
          obj['title'] = v.field_title;
          field.allowedPlaceholders.push(obj);
        }
      });
    });
  }

}
